import { formatBigNumbersWithSuffix } from '@cognite/cogs-utils';

function getCounterString(counter, showSuffix, unit) {
  var counterInString = showSuffix ? formatBigNumbersWithSuffix(counter) : counter.toLocaleString();
  return unit ? counterInString + " " + unit : counterInString;
}

export { getCounterString };
